export const messages = {
    nb: {
      Header1: `Kundeportal Kreditorforeningen!`,
      Paragraph1: `Ingen tilgang fordi du har ingen kreditorer registrert.`,      
    }
  } 